import HeroSection from './components/HeroSection';
import OverviewSection from './components/OverviewSection';
import PhilosophySection from './components/PhilosophySection';
import CapabilitiesSection from './components/CapabilitiesSection';
import StandardsSection from './components/StandardsSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <OverviewSection />
      <PhilosophySection />
      <CapabilitiesSection />
      <StandardsSection />
      <ContactSection />
    </main>
  );
}